<template>
    <a class="logo" href="https://www.fairvalue-calculator.com/">
        <img v-if="isAtLeastDesktop" :src='URI.getPrefix() + "/assets/images/logo.jpg"' alt="Fairvalue calculator" width="206px" height="48px" />

        <img v-else-if="isAtLeastTablet" :src='URI.getPrefix() + "/assets/images/logo_tablet.jpg"' alt="Fairvalue calculator" width="182px"
            height="42px" />

        <img v-else :src='URI.getPrefix() + "/assets/images/logo_mobile.jpg"' alt="Fairvalue calculator" width="130px" height="30px" />
    </a>
</template>

<script>
import URI from "../../helper/Uri"

export default {
    data: () => {
        return {
            URI: URI
        }
    },
    computed: {
        isAtLeastTablet() {
            return this.$store.getters.isAtLeastTablet()
        },
        isAtLeastDesktop() {
            return this.$store.getters.isAtLeastDesktop()
        },
    },
}


</script>